export const MinorIneligibleContent = {
  checklist: [
    `If you are the custodian, you will need the former minor to go through our web registration process. This will allow the former minor to complete the transfer from the UGMA/UTMA to an individual nonretirement account; or`,
    `Our records may indicate that the minor associated with the UGMA/UTMA has not yet reached the age of termination for the custodial account; or`,
    `There is no UGMA/UTMA custodial account on file or the account on file has a balance of zero. `,
  ],
  contactUs: {
    contactusHeading: `We can't complete your transfer at this time`,
    contactusDesc: `We apologize for any inconvenience. Please review the following information:`,
  },
  buttonLabel: 'View my accounts',
};
